import React, { useState, useEffect } from 'react';
import api from '../../../api';
import { useParams } from 'react-router-dom';

const OverviewSection = () => {
  const { miniSlug, slug } = useParams();
  const [showMore, setShowMore] = useState(false);
  const [overviewData, setOverviewData] = useState({
    content: '',
    extendedContent: '',
    image: null,
  });
  const [loading, setLoading] = useState(true);

  const addCheckIconToList = (html) => {
    if (!html) return '';
    return html.replace(
      /<li>/g,
      '<li><i className="fa fa-check-circle-o me-2"></i>'
    );
  };

  const createMarkupWithIcons = (content) => ({
    __html: addCheckIconToList(content),
  });

  const hasTextContent = (html) =>
    html && html.replace(/<[^>]*>/g, '').trim().length > 0;

  useEffect(() => {
    const fetchOverviewData = async () => {
      try {
        const response = await api.get(
          `${process.env.REACT_APP_API_URL}/api/${miniSlug}/${slug}`
        );

        const overview = response?.data?.sections?.overview;

        setOverviewData({
          content: overview?.overview_content || '',
          extendedContent: overview?.extended_content || '',
          image: overview?.overview_image || null,
        });
      } catch (error) {
        console.error('Error fetching overview data:', error);
        setOverviewData({
          content: '',
          extendedContent: '',
          image: null,
        });
      } finally {
        setLoading(false);
      }
    };

    fetchOverviewData();
  }, [miniSlug, slug]);

  // ✅ SAFE RETURNS AFTER HOOKS
  if (loading) return null;

const showOverview =
  hasTextContent(overviewData.content) || overviewData.image;

if (!showOverview) return null;


  return (
    <section className="overview_section" id="overview">
      <div className="container">

       {(hasTextContent(overviewData.content) || overviewData.image) && (
          <div className="sec-title text-center">
            <h2>Overview</h2>
          </div>
        )}
        <div className="row">
          {overviewData.image && (
            <div className="col-lg-5 order-1 order-lg-2 text-center mb-3">
              <img
                src={`${process.env.REACT_APP_API_URL}/public${overviewData.image}`}
                alt="College overview"
                className="img-fluid"
              />
            </div>
          )}

          {hasTextContent(overviewData.content) && (
            <div
              className={`col-lg-${overviewData.image ? '7' : '12'} order-2 order-lg-1 read-more-section text-center text-md-start`}
            >
              <div
                className="school-college-list"
                dangerouslySetInnerHTML={createMarkupWithIcons(
                  overviewData.content
                )}
              />

              {hasTextContent(overviewData.extendedContent) && (
                <>
                  <div
                    className="more-text school-college-list"
                    style={{ display: showMore ? 'block' : 'none' }}
                    dangerouslySetInnerHTML={createMarkupWithIcons(
                      overviewData.extendedContent
                    )}
                  />

                  <div className="d-flex justify-content-start align-items-start">
                    <button
                      className="btn-one btn-smaller read-more mb-3"
                      onClick={() => setShowMore(!showMore)}
                    >
                      <span className="txt">
                        {showMore ? 'Read Less' : 'Read More'}
                      </span>
                    </button>
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default OverviewSection;
